jQuery(window).bind("pageshow", function (event) {
    var uagent = navigator.userAgent.toLowerCase();
    if (event.originalEvent.persisted && /safari/.test(uagent) && !/chrome/.test(uagent)) {
        window.location.reload()
        jQuery('#loader').fadeOut(800);
        jQuery('body').animate({
            opacity: 1
        }, 800);
    }
});

// JQuery Start
jQuery(document).ready(function ($) {

    // Remove loader when document is ready
    $('#loader').fadeOut(800);

    // autoplay on video if higher res than 950px
    if ($(window).width() <= 950) {
        $('video').prop('autoplay', false);
    }


    /*========================================
    =            Page transitions            =
    ========================================*/
    var body = $('body');
    var bodyHtml = $('body', 'html');
    var mainNavTags = $('#main-nav ul li a');
    var logo = $('div.logo a');
    var coverBtn = $('#frontpage-cover a.a-btn');


    function removeHashFromUrl(url) {
        return url.split('#')[0];
    }

    function urlHasHash(url) {
        return typeof (url.split('#')[1]) !== 'undefined';
    }

    function getHashFromUrl(url) {
        return '#' + url.split('#')[1];
    }

    function scrollTo(element) {
        $('html, body').animate({
            scrollTop: element.offset().top - $('header').height()
        }, 500);
    }

    // Load animations on page transitions
    var newLocation;

    function newpage() {
        window.location = newLocation;
    }
    bodyHtml.animate({
        opacity: 1
    }, 800);
    mainNavTags.add(logo).add(coverBtn).on('click', function () {
        event.preventDefault();

        if (urlHasHash(this.href)) {
            if (removeHashFromUrl(location.href) === removeHashFromUrl(this.href)) {
                scrollTo($(getHashFromUrl(this.href)));
                return;
            }
        }

        newLocation = this.href;
        body.animate({
            opacity: 0
        }, 350, newpage);
    });

    /*=====================================
    =            Smooth scroll            =
    =====================================*/
    $('body').on('click', 'a', function () {
        scrollTo($(getHashFromUrl($.attr(this, 'href'))))
        return false;
    });


    //
    //
    // Modalbox
    //
    //

    // vars needed
    var modalBox = $('div.inner-modal'),
        modalOverlay = $('div.modal-overlay'),
        modalContent = $('div.modal-content');


    // toggle modal
    function toggleModal() {
        $('div.modal-content').addClass('no-close');
        modalOverlay.show();
        setTimeout(function () {
            modalOverlay.addClass('disp');
            setTimeout(function () {
                modalBox.addClass('disp');
            }, 100);
        }, 100);
    }

    // hide modal
    function removeModal(e) {
        // if clicked inside modal box, ignore it
        if ($(e.target).closest('.no-close')[0]) {
            return false;
        } else {
            modalOverlay.removeClass('disp');
            modalBox.removeClass('disp');
            $('.galleri-arrow').remove();
            $('.active-galleri-box').removeClass('active-galleri-box');
            setTimeout(function () {
                modalOverlay.hide();
                modalBox.removeClass('img-modal');
                modalBox.parent().parent().removeClass('autoWidth');
            }, 300);
            modalContent.find('iframe').attr('src', '');
        }
    }

    // bind button to toggle modal
    $('.video').on('click', function (e) {
        e.preventDefault();
        toggleModal();
        var textstring = $(this).find('p.hidden-link').text();
        var textToAppend = textstring.replace('https://vimeo.com/', '');
        var videoToAppend = 'https://player.vimeo.com/video/' + textToAppend;
        modalContent.find('iframe').attr('src', videoToAppend)
    });

    // bind overlay to hide modal
    modalOverlay.on('click', function (e) {
        removeModal(e);
    });

    // hide modal on esc keyup
    $(document).keyup(function (e) {
        if (e.which === 27) {
            removeModal(e);
        }
    });

    /**
     * Object-fit poly-fill for IE & Edge
     */

    if ('objectFit' in document.documentElement.style === false) {
        var container = document.getElementsByClassName('object-fit');

        for (var i = 0; i < container.length; i++) {
            var imageSource;
            if (container[i].querySelector('img').hasAttribute('lazy-load')) {
                imageSource = container[i].querySelector('img').getAttribute('full');
            } else {
                imageSource = container[i].querySelector('img').src;
            }
            container[i].querySelector('img').style.display = 'none';
            container[i].style.backgroundSize = 'cover';
            container[i].style.backgroundImage = 'url(' + imageSource + ')';
            container[i].style.backgroundPosition = 'center center';
            container[i].style.backgroundRepeat = 'no-repeat';
        }
    }

    /*======================================
    =            Responsive Nav            =
    ======================================*/
    var pullMenu = $('.pull_menu'); // The Pull menu item which trigger the whole menu
    var header = $('nav'); // The header where all elements are inside.
    var line1 = $('.line-1'); //Navigation Rectangle 1
    var line2 = $('.line-2'); // Navigation Rectangle 2
    var line3 = $('.line-3'); // Navigation Rectangle 3

    pullMenu.click(function () {
        header.toggleClass('pull_menu_in_out');
        line1.toggleClass('line-1-animate');
        line2.toggleClass('line-2-remove');
        line3.toggleClass('line-3-animate');
        $('body').toggleClass('no-scroll');
        $('.special-header').toggleClass('scrolled');
    });


    /*======================================
    =            Number effects            =
    ======================================*/
    var doingCounterAnimation = [];

    function doCount() {
        var scrollPosition = $(window).scrollTop();
        if (scrollPosition > $('.thenumber').offset().top - $(window).height()) {
            $('.thenumber').each(function (index) {
                if (typeof (doingCounterAnimation[index]) === 'undefined') {
                    doingCounterAnimation[index] = false;
                }
                if (!doingCounterAnimation[index]) {
                    $(this).prop('Counter', 0).stop().animate({
                        Counter: $(this).attr('data-number')
                    }, {
                        duration: 3500,
                        easing: 'swing',
                        step: function (now) {
                            $(this).text(Math.ceil(now));
                        },
                        start: function () {
                            doingCounterAnimation[index] = true;
                        }
                    });
                }
            });
        }
    }

    // init if present and inside view
    if ($('.number-block').length > 0) {
        $(window).on('scroll', function () {
            doCount();
        });
        $('.thenumber').each(function () {
            $(this).attr('data-number', $(this).text());
            $(this).text('0');
        });
        doCount();
    }



    /*================================================
    =            Swap sections responsive            =
    ================================================*/
    function jqUpdateSize() {
        // Get the dimensions of the viewport
        var width = $(window).width();

        if (width < 986) {
            $('.swap').each(function () {
                if (!$(this).text().match(/^\s*$/)) {
                    $(this).insertBefore($(this).prev('.swap'));
                }
            });
        } else {
            $('.swap').each(function () {
                if (!$(this).text().match(/^\s*$/)) {
                    $(this).insertAfter($(this).next('.swap'));
                }
            });
        }
        if (width < 406) {
            $('.swip').each(function () {
                if (!$(this).text().match(/^\s*$/)) {
                    $(this).insertBefore($(this).prev('.swip'));
                }
            });
        } else {
            $('.swip').each(function () {
                if (!$(this).text().match(/^\s*$/)) {
                    $(this).insertAfter($(this).next('.swip'));
                }
            });
        }
    }
    jqUpdateSize(); // When the page first loads
    $(window).resize(jqUpdateSize); // When the browser changes size



    /*================================================
    =            toggle checkbox on click            =
    ================================================*/
    $('.remember-me').on('click', function () {
        var inputs = $(this).find('input:checkbox');
        if ($(this).find('input:checkbox').prop('checked') === true) {
            $(this).find('input:checkbox').prop('checked', false);
            $(this).removeClass('checked');
        } else {
            inputs.each(function () {
                $(this).prop('checked', true)
            });
            $(this).addClass('checked');
        }
    });

    $('.checkbox span').on('click', function () {
        $(this).closest('.checkbox').click();
    });

    $(document).on('mailsent.wpcf7', function () {
        $('.checkbox').removeClass('checked');
    });



    /*============================================
    =            Sticky nav on scroll            =
    ============================================*/
    // var mainHeader = $('.header-wrap');
    // if (mainHeader.length > 0) {
    //     var stickyNavTop = mainHeader.offset().top + 150;

    //     var stickyNav = function() {
    //         if ($('header').css('height') !== '60px') {
    //             var scrollTop = $(window).scrollTop();

    //             if (scrollTop > stickyNavTop) {
    //                 mainHeader.addClass('sticky');
    //             } else {
    //                 mainHeader.removeClass('sticky');
    //             }
    //         }
    //     };

    //     stickyNav();

    //     $(window).scroll(function() {
    //         stickyNav();
    //     });
    // }



    /*==========================================
    =       Swap cover between 3 images        =
    ==========================================*/
    var cover = $('div.cover');

    function slideSwitch() {
        var active = $('div#slideshow .img.active');
        var next = active.next('.img');
        var slideShow = $('#slideshow').find('.img');

        // if next is not an img -> restart slideshow
        if (next.length === 0) {
            next = $('div#slideshow .img').first();
        }

        // init slideshow has more than 1 image
        if (slideShow.length > 1) {
            next.addClass('active');
            active.removeClass('active');
        }
    }

    setInterval(function () {
        slideSwitch();
    }, 4000);



    /*===================================================
    =            Scroll back to top - footer            =
    ===================================================*/
    $(window).scroll(function () {
        if ($(window).scrollTop() + $(window).height() > $(document).height() - 300) {
            $('.arrowup').addClass('animateMeTop');
            $('.scrollToTop').addClass('animatescrolltotop');
        }
    });

    $('.scrollToTop').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 'slow');
        return false;
    });


    // Append name in hidden input
    var hiddenInput = $('#hidden-anledning');
    if (hiddenInput.length > 0) {
        var data = $('.cover').find('h1').text();
        hiddenInput.val(data);
    }

    $(document).on('click', '.galleri-box', function () {

        $(this).addClass('active-galleri-box');

        toggleModal();
        modalBox.addClass('img-modal');
        modalBox.parent().parent().addClass('autoWidth');
        var img = $(this).attr('data-img');
        modalContent.html('<img src="' + img + '">');

        setTimeout(function () {

            $('body').append('<div class="galleri-arrow arw-left" data-direction="left">');
            $('body').append('<div class="galleri-arrow arw-right" data-direction="right">');

        }, 200);

    });

    var galleriImgs = $('.galleri-box').length - 1;

    $(document).on('click', '.galleri-arrow', function () {

        var direction = $(this).attr('data-direction');

        if (direction == 'left') {

            var cur = parseInt($('.active-galleri-box').attr('data-id')),
                next = cur - 1;

            if (next < 0) {
                next = galleriImgs;
            }

            $('.active-galleri-box').removeClass('active-galleri-box');
            $('.galleri-box[data-id="' + next + '"]').addClass('active-galleri-box');

            var imgToAppend = $('.active-galleri-box').attr('data-img');

            modalContent.html('<img src="' + imgToAppend + '">');

        } else if (direction == 'right') {

            var cur = parseInt($('.active-galleri-box').attr('data-id')),
                next = cur + 1;

            if (next > galleriImgs) {
                next = 0;
            }

            $('.active-galleri-box').removeClass('active-galleri-box');
            $('.galleri-box[data-id="' + next + '"]').addClass('active-galleri-box');

            var imgToAppend = $('.active-galleri-box').attr('data-img');

            modalContent.html('<img src="' + imgToAppend + '">');

        } else {
            // Nothing
        }

    });

    $("body").keydown(function (e) {
        if (e.keyCode == 37) { // left
            var cur = parseInt($('.active-galleri-box').attr('data-id')),
                next = cur - 1;

            if (next < 0) {
                next = galleriImgs;
            }

            $('.active-galleri-box').removeClass('active-galleri-box');
            $('.galleri-box[data-id="' + next + '"]').addClass('active-galleri-box');

            var imgToAppend = $('.active-galleri-box').attr('data-img');

            modalContent.html('<img src="' + imgToAppend + '">');
        } else if (e.keyCode == 39) { // right
            var cur = parseInt($('.active-galleri-box').attr('data-id')),
                next = cur + 1;

            if (next > galleriImgs) {
                next = 0;
            }

            $('.active-galleri-box').removeClass('active-galleri-box');
            $('.galleri-box[data-id="' + next + '"]').addClass('active-galleri-box');

            var imgToAppend = $('.active-galleri-box').attr('data-img');

            modalContent.html('<img src="' + imgToAppend + '">');
        }
    });

    function scrolled() {

        var offset = $(window).scrollTop(),
            header = $('.special-header');

        var scrolledClass = 'scrolled';

        if (offset > 10) {
            header.addClass(scrolledClass);
        } else {
            header.removeClass(scrolledClass);
        }

    }

    if ($('.special-header').length) {

        //$(window).scroll(scrolled);

    }

    /**
     * Modal for COVID
     * Will set a cookie so the modal is only displayed once
     */
    jQuery('.mtt-modal-wrap').on('click', function (e) {
        if (e.target !== e.currentTarget) {
            return false;
        }

        jQuery(this).removeClass('mtt-modal-wrap--active');
        $.cookie('covid_popup', 'true', {
            expires: 60
        });
    });

    jQuery('.mtt-modal__close').on('click', function () {
        jQuery(this).closest('.mtt-modal-wrap').removeClass('mtt-modal-wrap--active');
        $.cookie('covid_popup', 'true', {
            expires: 60
        });
    });

    if (!$.cookie('covid_popup')) {
        jQuery('#covid-modal').addClass('mtt-modal-wrap--active');
    }

});